import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { AdaFriendlyNamePipe } from '../pipes/ada-friendly-name.pipe';
import { OfferUtilService } from './offer-util.service';
import { ScrollFocusService } from './scroll-focus.service';

@Injectable({
  providedIn: 'root'
})
export class FootnoteService {
  supPriceId= 'data-sup-price-id';
  supAddinfoId= 'data-sup-addinfo-id';
  supScrollId='data-sup-scroll-id';

  constructor(private adaFriendlyNamePipe: AdaFriendlyNamePipe,
    private offerUtilService: OfferUtilService,
    @Inject(PLATFORM_ID) private platformId: string
    ) { }

  addFootNote(elementRef, renderer2, cardDetail: CardDetailFootNote, callback?, sourceObj?,page='', type=''){
    if(!isPlatformBrowser(this.platformId)){
      return;
    }
    this.mapFields(cardDetail);
    if(!cardDetail.pidPT){
      cardDetail.pidPT = cardDetail.pid + (cardDetail.productType ? '_'+cardDetail.productType : '');
    }
    if(type==='scroll' && page==='pdp'){
      this.setScrollFocus(elementRef,renderer2,cardDetail, callback, sourceObj, page)
    }else{
      this.addPricingInfo(elementRef, renderer2, cardDetail);
      if(callback && sourceObj){
        this.addAdditionalInfo(elementRef, renderer2, cardDetail, callback, sourceObj);
      }
    }
  }
  private addPricingInfo(elementRef, renderer2, cardDetail: CardDetailFootNote){
    let attributes = cardDetail?.pricingInfoFootnoteAttributes || {};
    if(cardDetail?.pricingInfoLink) {
      attributes['href'] = cardDetail?.pricingInfoLink
    }
    if(cardDetail?.cardName || cardDetail?.pricingInfo){
      attributes['aria-label'] = this.adaFriendlyNamePipe.ariaLabel((cardDetail?.cardName || '')+ ' 1 ' + (cardDetail?.pricingInfo || ''));
    }
    this.offerUtilService.injectDynamicElAttr(elementRef, renderer2, `[${this.supPriceId}='${cardDetail.pidPT || cardDetail.pid}']`,attributes);
  }
  private addAdditionalInfo(elementRef, renderer2, cardDetail: CardDetailFootNote, callback, sourceObj){
    let attributes = cardDetail?.additionalInfoFootnoteAttributes || {};
      if(cardDetail?.cardName || cardDetail?.additionalInformationText){
        attributes['aria-label'] = this.adaFriendlyNamePipe.ariaLabel((cardDetail?.cardName || '')+ ' 2 ' + (cardDetail?.additionalInformationText || ''));
      }
      const events = [{
        'event': 'click',
        'callback': callback,
        'args': [cardDetail.cardName,cardDetail?.pDPContentID || cardDetail?.contentId]
      },
      {
        'event': 'keyup.enter',
        'callback': callback,
        'args': [cardDetail.cardName,cardDetail?.pDPContentID || cardDetail?.contentId]
      }];
      this.offerUtilService.injectDynamicElAttr(elementRef, renderer2, `[${this.supAddinfoId}='${cardDetail.pidPT || cardDetail.pid}']`,attributes,events, sourceObj);
    }
  private setScrollFocus(elementRef, renderer2, cardDetail: CardDetailFootNote, callback, sourceObj, page=''){
    const attributes = cardDetail?.scrollFootnoteAttributes || {};
    let scrollToId = '';
    //set Attributes
    this.offerUtilService.injectDynamicElAttr(elementRef, renderer2, `[${this.supScrollId}='${cardDetail.pidPT || cardDetail.pid}']`,attributes);

    // set events based on the footnote targetId
    let dynamicVariableElementList = this.offerUtilService.getDynamicElements(elementRef, `[${this.supScrollId}='${cardDetail.pidPT || cardDetail.pid}']`);
    for (const dynamicVariableElement of dynamicVariableElementList) {
      scrollToId = (dynamicVariableElement as HTMLElement)?.getAttribute('data-scroll-target-id');
      if(!scrollToId && page === 'pdp'){
        scrollToId = '#pricingDetailsSection';
      }
      if(scrollToId){
        const events = [{
          'event': 'click',
          'callback': callback,
          'args': [scrollToId, page]
        },
        {
          'event': 'keyup.enter',
          'callback': callback,
          'args': [scrollToId, page]
        }];
        this.offerUtilService.setDynamicElEvents(dynamicVariableElement, renderer2, events, sourceObj);
      }
    }
  }

  private mapFields(cardDetail){
    const fields = {'pid':'PID','pDPContentID':'PDPContentID','pricingInfo':'cardPricingDetailText|pricingInformation','pricingInfoLink':'pricingInfolink'};
    for (const [key,val] of Object.entries(fields)){
      (val.split('|')).forEach(sVal=>{
        if(!cardDetail?.[key] && cardDetail?.[sVal]){
          cardDetail[key]=cardDetail?.[sVal];
        }
      });
    }
  }
}
export interface CardDetailFootNote{
  pid: string,
  pidPT?: string,
  productType?: string,
  cardName: string,
  pricingInfo?: string,
  pricingInfoFootnoteAttributes?: any,
  additionalInfoFootnoteAttributes?: any,
  scrollFootnoteAttributes?: any,
  pricingInfoLink?: string,
  additionalInformationText?: string,
  pDPContentID?: string,
  contentId?: string
}
export interface UpdateElement{
  [key: string]: string
}
export interface ElementEvents{
  event: string,
  callback: any,
  args: Array<string | boolean | number>
}
